<script>

/**
 * Automodal 
 * 
 * Version 1.0
 * Placeholder base
 */

import _ from 'lodash'

import {archetype, automodalHandler} from './archetype'

export default {
    name: 'conceptIngredientesAutomodal',
    props: {
        modalSize: {
            type: String,
            default: 'md'
        },
        conceptId: {
            type: [String, Number],
        },
        archetype: {
            type: [Array, Object],
            default: () => archetype
        }
    },
    data: () => {
        return {
            form: {
                id_pk: null
            },
            asides: {
                categoriasnutricionals: []
            }
        }
    },
    computed: {
        cArchetype(){
            let updated = [];
            _.forEach(archetype, itemsRow => {
                if(!_.isArray(itemsRow)){
                    updated.push(itemsRow);
                    return
                } 
                let adding = []
                _.forEach(itemsRow, item => {
                    // EVALUACIÓN DINÁMICA POR ELEMENTO DE ARQUETIPO

                    if(item.key == 'idcategorianutricion_fk'){
                        item.options = this.asides.categoriasnutricionals
                    }

                    adding.push(item)
                })
                updated.push(adding)
            })
            return updated
        }
    },
    methods: {
        getHandler(){
            return automodalHandler(this.conceptId)
        },
        refresh(){
            this.$emit('refresh');
        },
        checkAsides(){
            const asides = this.$refs.automodal.getAsides();
            if(!!asides){
                this.asides.categoriasnutricionals                      = asides.categoriasnutricionals
            }
        },
        onDisplay(){
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL HA CARGADO DOM COMPLETAMENTE.
        },

    },
    watch: {
        'form.id'(){
            
        }
    }
}
</script>

<template>
    <div>
        <ui-edit-auto-modal v-model="form" ref="automodal" :form-archetype="cArchetype" @refresh="refresh()" :handler="getHandler()" :size="modalSize" @defined="checkAsides()" @display="onDisplay" :allow-aside="false" :allow-delete="true" :form-id="form.id_pk">
            <slot name="default"><i class="fa fa-cog"></i></slot>
            <b-col slot="aside" cols="7">
                <!-- LATERAL, REQUIERE :allow-aside="true" -->
            </b-col>
            <b-col slot="bottom" v-if="false">
                <!-- AGREGAR AL FONDO... -->
                {{form}}
            </b-col>
        </ui-edit-auto-modal>
    </div>
</template>